module.exports = "<p>\n  {{( selectedPanoramaTree$ |async)?.id }}\n</p>\n\n\n"